export default "__VITE_ASSET__CNpUwqcr__"